import { Component, Input, ChangeDetectionStrategy, OnInit } from '@angular/core';
import {RequestUserStatus} from '../../../model/enum/request-user-status.enum';
import { CplUserRequest } from '../../../model/cpl-user-request.model';
import { DatePipe } from '@angular/common';
import { DateHelpers } from '@edl-development/edl-common';

@Component({
    selector:    'request-progress',
    templateUrl: './request-status-progress.component.html',
    styleUrls:   ['./request-status-progress.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RequestStatusProgressComponent implements OnInit {
    
    @Input() request: CplUserRequest;

    RequestUserStatus = RequestUserStatus;
    datePipe = new DatePipe('en-US');
    followUpLabel: string;
    completedLabel:string;
    submittedLabel:string;
    ngOnInit(): void {
        this.followUpLabel = this.getFollowupLabel();
        this.completedLabel = this.getCompletedLabel();
        this.submittedLabel = this.getSubmittedLabel();
    }

    IsSubmittedStatus(){
        return (this.request.UserStatus == RequestUserStatus.Submitted || DateHelpers.isMinDate(this.request.ApprovedDate)) && this.request.UserStatus != RequestUserStatus.Cancelled;
    }

    IsApproved(){
        return (this.request.UserStatus >= RequestUserStatus.Approved || !DateHelpers.isMinDate(this.request.ApprovedDate)) && this.request.UserStatus != RequestUserStatus.Cancelled;
    }

    CheckStatus(statusCheck:RequestUserStatus ){
        if(statusCheck==undefined) return false;
        switch(statusCheck){
            case RequestUserStatus.FollowUpRequired:
                return this.request.UserStatus == RequestUserStatus.FollowUpExpired ||
                    this.request.UserStatus == RequestUserStatus.FollowupExpiring ||
                    this.request.UserStatus == RequestUserStatus.PendingFollowUp;
                
            case RequestUserStatus.FollowUpApproved:
                let isApproved = (
                        this.request.UserStatus == RequestUserStatus.Completed 
                        || !DateHelpers.isMinDate(this.request.CompletedDate)) 
                    && this.request.UserStatus != RequestUserStatus.Cancelled 
                    && this.request.FollowupStatusID != RequestUserStatus.FollowupForgiven ;
                return isApproved;
            case RequestUserStatus.FollowupForgiven:
                return this.request.FollowupStatusID == RequestUserStatus.FollowupForgiven &&
                    this.request.UserStatus == RequestUserStatus.Completed;
            default:
                return this.request.UserStatus == statusCheck;

        }
    }

    IsCancelled(){
        return this.request.UserStatus == RequestUserStatus.Cancelled;
    }

    IsCompleted(){
        return this.request.UserStatus == RequestUserStatus.Completed;
    }

    IsDisapproved(){
        return this.request.UserStatus == RequestUserStatus.Disapproved;
    }

    IsStep1Active(){
        return this.IsApproved() || this.request.UserStatus == RequestUserStatus.Submitted;
    }

    getSubmittedLabel(){
        if(this.IsApproved()){
            return `Approved on ${this.datePipe.transform(this.request.ApprovedDate, 'short')}` ;
        }
        else if(!DateHelpers.isMinDate(this.request.SubmissionDate))
            return `Submitted on ${this.datePipe.transform(this.request.SubmissionDate, 'short')}  --  ${this.request.PendingStatus}` ;
    }

    getApprovedLabel(){
        return "";
    }

    getFollowupLabel() {
        switch (this.request.UserStatus){
            case RequestUserStatus.PendingFollowUp:
                    return  `Follow-Up due on ${this.datePipe.transform(this.request.FollowupDueDate, 'short')}`;
            case RequestUserStatus.FollowUpExpired:
                    return  `Follow-Up due on ${this.datePipe.transform(this.request.FollowupDueDate, 'short')} expired`;
            case RequestUserStatus.FollowupExpiring:
                    return  `Follow-Up due on ${this.datePipe.transform(this.request.FollowupDueDate, 'short')}`;
            case RequestUserStatus.FollowupSubmitted:
                    return  `Follow-Up submitted on ${this.datePipe.transform(this.request.FollowupSubmissionDate, 'short')} --  ${this.request.PendingStatus}`;             
            case RequestUserStatus.Completed:
                if(this.request.FollowupStatusID == RequestUserStatus.FollowupForgiven) return  `Follow-Up forgiven on ${this.datePipe.transform(this.request.ModifiedDate, 'short')}`;
                else if(this.request.FollowupStatusID == RequestUserStatus.Approved) return  `Follow-Up approved on ${this.datePipe.transform(this.request.ModifiedDate, 'short')}`;
            default:
                if (!this.request.HasFollowup) return 'No Follow-Up Required';
                else return '';
        }
    }
    getCompletedLabel(){
        switch (this.request.UserStatus){
            case RequestUserStatus.Completed:
                    return  `Completed on ${this.datePipe.transform(this.request.CompletedDate, 'short')}`;
            case RequestUserStatus.Cancelled:
                    return  `Cancelled on ${this.datePipe.transform(this.request.ModifiedDate, 'short')}`;
            case RequestUserStatus.Disapproved:
                    return  `Disapproved on ${this.datePipe.transform(this.request.ModifiedDate, 'short')}`;
            default:
                return "";
        }
        
    }
    
    getFollowupIcon() {
        if (!this.CheckStatus(RequestUserStatus.Cancelled) && !this.CheckStatus(RequestUserStatus.FollowUpApproved) && !this.CheckStatus(RequestUserStatus.FollowupForgiven)) {
            return 'fas fa-calendar-alt';
        } else if(this.CheckStatus(RequestUserStatus.Cancelled)) {
            return 'fas fa-minus';
        } else if(this.CheckStatus(RequestUserStatus.FollowUpApproved)) {
            return 'fas fa-check';
        } else if (this.CheckStatus(RequestUserStatus.FollowupForgiven)) {
            return 'fas fa-asterisk';
        } else {
            return '';
        }
    }
}